"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserData = exports.roles = void 0;
exports.roles = {
    admin: "admin",
    na: "na",
};
class User {
    constructor() {
        this.role = exports.roles.na;
        this.data = new UserData();
        this.uid = "";
        // Only used for user interface
        this.dirty = false;
        this.password = null;
        this.client = null;
    }
}
exports.default = User;
class UserData {
    constructor() {
        this.email = "";
        this.displayName = "";
    }
}
exports.UserData = UserData;
